export default "__VITE_ASSET__CspwF3g9__"